export default class Menu {
    constructor(manager){

        //manager
        this.manager = manager;

        //dom
        this.$trigger = document.getElementById('l-menu__trigger');
        this.$triggerOpen = this.$trigger.querySelector('.-menu');
        this.$triggerClose = this.$trigger.querySelector('.-close');
        this.$iconBorder = [].slice.call(this.$trigger.querySelectorAll('.border'));
        this.$wrap = document.getElementById('l-menu');
        this.$anime = document.querySelectorAll('#l-menu .js__show-x');
        this.$bg = document.getElementById('l-menu-bg');
        this.$hover = [].slice.call(document.querySelectorAll('#l-menu .link'));
        this.$hoverLink = this.$hover.filter(i => i !== this.$hover[2]); // SCENE以外
        this.$hoverSubLink = document.querySelectorAll('#l-menu .subLink');
        //status
        this.status = {
            open:false,
            mot:false
        }
        this.white = 'rgb(255,255,255)';

    }
    init(){

        this.$trigger.addEventListener("click",()=>{
            if(this.status.mot) return;
            this.status.mot = true;
            if(this.status.open){
                this.hide();
            }else{
                this.show();
            }
        });

        if(Useragnt.pc){
            // ボタンのhover動作
            for (let i in this.$hover) {
                if(this.$hover[i].nodeType!=1) continue; // dom要素以外は処理止める
                this.$hover[i].addEventListener("mouseenter", () => {
                    this.enter(i);
                })
                this.$hover[i].addEventListener("mouseleave", () => {
                    this.leave(i);
                })
            }
            // サブリンクのhover動作
            for(let i in this.$hoverSubLink){
                if(this.$hoverSubLink[i].nodeType!=1) continue; // dom要素以外は処理止める
                this.$hoverSubLink[i].addEventListener("mouseenter",()=>{
                    this.enter(i, 'subLink');
                })
                this.$hoverSubLink[i].addEventListener("mouseleave",()=>{
                    this.leave(i, 'subLink');
                })
            }
        }

    }
    show(){

        TweenMax.killTweensOf([this.$wrap,this.$anime,this.$bg,this.$triggerOpen,this.$triggerClose,this.$iconBorder]);

        this.status.open = true;
        this.$trigger.classList.add('is-open');
        this.color = this.$iconBorder[0].style.backgroundColor;

        TweenMax.set(this.$wrap,{
            opacity:1,
            display:'block'
        });
        TweenMax.staggerFromTo(this.$anime,1.6,{
            x:-55,
            opacity:0,
            rotation:1,
        },{
            delay:0.85,
            x:0,
            opacity:1,
            rotation:0,
            ease:this.manager.ease
        },0.05);

        TweenMax.fromTo(this.$bg,1.4,{
            opacity:0,
            display:'none',
        },{
            opacity:1,
            display:'block',
            ease:this.manager.ease,
            onComplete: () => {
                this.status.mot = false;
                this.$wrap.classList.add('is-open')
            }
        });

        TweenMax.fromTo(this.$triggerOpen,.4,{
            opacity: 1,
            color: this.color,
        }, {
            opacity: 0,
            color: this.white,
            ease: Power2.easeOut,
            onComplete: () => {
                this.$triggerOpen.style.visibility = 'hidden';
            },
        })

        TweenMax.fromTo(this.$triggerClose,1.2,{
            opacity: 0,
            x: -10,
            color: this.color,
        }, {
            opacity: 1,
            x: 0,
            color: this.white,
            ease: Power2.easeOut,
            onStart: () => {
                this.$triggerClose.style.visibility = 'visible';
            },
        })

        TweenMax.to(this.$iconBorder, 1.2,{
            backgroundColor: this.white,
            ease: Power2.easeOut,
        });
    }
    hide(){

        TweenMax.killTweensOf([this.$wrap,this.$bg,this.$triggerOpen,this.$triggerClose,this.$iconBorder]);

        this.status.open = false;
        this.$trigger.classList.remove('is-open');

        TweenMax.staggerTo(this.$anime,1.3,{
            x: 55,
            opacity:0,
            rotation:-1,
            ease:this.manager.ease
        },0.025);

        TweenMax.to(this.$bg,1.5,{
            opacity:0,
            display:'none',
            ease:this.manager.ease,
            onComplete: () => {
                this.status.mot = false;
                TweenMax.set([this.$wrap,this.$bg], {
                    display:'none',
                    opacity:0,
                });
            }
        });

        TweenMax.fromTo(this.$triggerOpen,1.2,{
            opacity: 0,
            x: -10,
            color: this.white,
        }, {
            opacity: 1,
            x: 0,
            color: this.color,
            ease: Power2.easeOut,
            onStart: () => {
                this.$triggerOpen.style.visibility = 'visible';
            },
        })

        TweenMax.fromTo(this.$triggerClose,.4,{
            opacity: 1,
            color: this.white,
        }, {
            opacity: 0,
            color: this.color,
            ease: Power2.easeOut,
            onComplete: () => {
                this.$triggerClose.style.visibility = 'hidden';
            },
        })

        TweenMax.to(this.$iconBorder, 1.2,{
            backgroundColor: this.color,
            ease: Power2.easeOut,
        });
    }
    enter(index, type) {
        if (Number(index) === 2) return;

        if (type === 'subLink') {
            for(let i in this.$hoverSubLink) {
                if (this.$hoverSubLink[i].nodeType != 1) continue; // dom要素以外は処理止める
                if(i !== index){
                    TweenMax.to(this.$hoverSubLink[i], 1.2 ,{
                        opacity:.2,
                        ease: Power2.easeOut,
                    });
                }
                // SCENE以外opacityを変更
                TweenMax.to(this.$hoverLink, 1.2 ,{
                    opacity:.2,
                    ease: Power2.easeOut,
                });
            }
        } else {
            for(let i in this.$hover) {
                if (this.$hover[i].nodeType != 1) continue; // dom要素以外は処理止める
                if(i != index){
                    TweenMax.to(this.$hover[i], 1.2 ,{
                        opacity:.2,
                        ease: Power2.easeOut,
                    });
                }
            }
        }
    }
    leave(index, type) {
        if (Number(index) === 2) return;

        if (type === 'subLink') {
            for(let i in this.$hoverSubLink) {
                if (this.$hoverSubLink[i].nodeType != 1) continue; // dom要素以外は処理止める
                if(i !== index) {
                    TweenMax.to(this.$hoverSubLink[i], 1.2, {
                        opacity: 1,
                        ease: Power2.easeOut,
                    });
                }
                // SCENE以外opacityを変更
                TweenMax.to(this.$hoverLink, 1.2 ,{
                    opacity: 1,
                    ease: Power2.easeOut,
                });
            }
        } else {
            for(let i in this.$hover) {
                if (this.$hover[i].nodeType != 1) continue; // dom要素以外は処理止める
                if(i != index) {
                    TweenMax.to(this.$hover[i], 1.2, {
                        opacity: 1,
                        ease: Power2.easeOut,
                    });
                }
            }
        }
    }
}
